import { AuthTokenExpiredException } from '@pkg/basic'
import { apiClient } from '../../constants'

export const getPortfolioDbFileStream = async (params: {
  getToken: () => Promise<string | null>
  id: string
  timestamp?: number
}): Promise<ReadableStream | undefined> => {
  const started = Date.now()
  try {
    const { getToken, id, timestamp } = params

    const token = await getToken()
    if (token === null) {
      throw new AuthTokenExpiredException()
    }
    const response = await apiClient.v1.portfolio[':id'].db.$get(
      {
        param: { id },
        query: { timestamp: timestamp?.toString() },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    if (!response.ok) {
      if (response.status === 401 || response.status === 404) {
        return undefined
      }
      throw new Error(
        `Failed to get portfolio DB file: ${response.status} ${response.statusText}`,
      )
    }
    if (!response.body) {
      throw new Error('Failed to get portfolio DB file: no response body')
    }
    return response.body
  } finally {
    console.log(`${Date.now() - started}ms getPortfolioDbFileStream`)
  }
}
